import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { TextAlertModal } from 'src/app/shared/modals/text-alert/text-alert-modal.component';

@NgModule({
    declarations: [
        TextAlertModal
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
        ReactiveFormsModule,
    ],
    exports: [
        TextAlertModal,
    ]
})
export class TextAlertModalModule {
}
